import { HierarchicalItem, PagedList } from '@martech-solution/utils/types';
import { http } from '@martech-solution/utils/utils';
import { IOrganizationChart, OrganizationChartAdd } from 'src/types/master_data/organizationChart.type';

const controller = 'master-data/organization-charts';

export const getOrganizationCharts = async (
  searchCondition: string | undefined,
  sequenceStatus: string,
  page: number,
  pageSize: number,
  orderBy?: string
) => {
  return await http.get<PagedList<IOrganizationChart>>(controller, {
    params: {
      name: searchCondition,
      sequenceStatus,
      page,
      pageSize,
      orderBy
    }
  });
};

export const getAllOrganizationCharts = async (
  searchCondition: string | undefined,
  sequenceStatus: string,
  leaderId?: number
) => {
  return await http.get<IOrganizationChart[]>(`${controller}/get-all`, {
    params: {
      name: searchCondition,
      sequenceStatus,
      leaderId
    }
  });
};

export const getAllOrganizationChartsDropdown = async (
  searchCondition: string | undefined,
  sequenceStatus: string,
  sequenceDutyIds?: string
) => {
  return await http.get<HierarchicalItem[]>(`${controller}/get-all`, {
    params: {
      name: searchCondition,
      sequenceStatus,
      sequenceDutyIds
    }
  });
};

export const getOrganizationChart = async (id: number) => {
  return await http.get<IOrganizationChart>(`${controller}/${id}`);
};

export const getOrganizationChartsDropdown = async () => {
  return await http.get<HierarchicalItem[]>(`${controller}/dropdown`);
};

export const addOrganizationChart = async (organizationChart: OrganizationChartAdd) => {
  return await http.post(controller, organizationChart);
};

export const updateOrganizationChart = async (id: number, organizationChart: OrganizationChartAdd) => {
  return await http.put(`${controller}/${id}`, organizationChart);
};

export const deleteOrganizationChart = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};
